import { useGetBreeds } from '@application/api';
import { useRouter } from '@application/utils';
import { useEffect, useMemo } from 'react';

// TC-1410 - if path param breed is a sub-breed, redirect to parent breed
export const useRedirectToParentBreed = () => {
  const { navigateToRoute, infoFromCurrentPath } = useRouter();

  const { getParentBreedName } = useGetBreeds();

  const breedFromPathParam = useMemo(() => {
    return infoFromCurrentPath.params?.length ? decodeURI(infoFromCurrentPath.params[0]) : null;
  }, [infoFromCurrentPath.params]);

  const parentBreedName = useMemo(() => {
    if (breedFromPathParam) {
      return getParentBreedName(breedFromPathParam);
    }
  }, [breedFromPathParam, getParentBreedName]);

  useEffect(() => {
    if (!!breedFromPathParam && breedFromPathParam !== parentBreedName) {
      navigateToRoute(infoFromCurrentPath.route, { params: [parentBreedName as string] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breedFromPathParam, parentBreedName]);

  return null;
};
